export const BE_ERRORS = {
    ERR_EMAIL_REGISTERED: 'ERR_EMAIL_REGISTERED',
    ERR_THIRD_PARTY_ACCOUNT_REGISTERED: 'ERR_THIRD_PARTY_ACCOUNT_REGISTERED',
    ERR_PASSWORD_NOT_MATCH_PATTERN: 'ERR_PASSWORD_NOT_MATCH_PATTERN',
    ERR_EMAIL_ADDRESS_INVALID: 'ERR_EMAIL_ADDRESS_INVALID',
    ERR_OAUTH_SERVICE_NOT_SUPPORTED: 'ERR_OAUTH_SERVICE_NOT_SUPPORTED',
    ERR_WRONG_EMAIL_OR_PASSWORD: 'ERR_WRONG_EMAIL_OR_PASSWORD',
    ERR_EMAIL_NOT_REGISTERED: 'ERR_EMAIL_NOT_REGISTERED',
    ERR_BASIC_AUTH_INVALID: 'ERR_BASIC_AUTH_INVALID',
    ERR_REFRESH_TOKEN_EXPIRED: 'ERR_REFRESH_TOKEN_EXPIRED',
    ERR_REFRESH_TOKEN_INVALID: 'ERR_REFRESH_TOKEN_INVALID',
    ERR_OAUTH_TOKEN_INVALID: 'ERR_OAUTH_TOKEN_INVALID',
    ERR_FACEBOOK_OAUTH_TOKEN_INVALID: 'ERR_FACEBOOK_OAUTH_TOKEN_INVALID',
    ERR_FACEBOOK_OAUTH_APP_ID_INVALID: 'ERR_FACEBOOK_OAUTH_APP_ID_INVALID',
    ERR_APPLE_OAUTH_CLIENT_ID_INVALID: 'ERR_APPLE_OAUTH_CLIENT_ID_INVALID',
    ERR_APPLE_OAUTH_TOKEN_INVALID: 'ERR_APPLE_OAUTH_TOKEN_INVALID',
    ERR_ETHEREUM_OAUTH_TOKEN_INVALID: 'ERR_ETHEREUM_OAUTH_TOKEN_INVALID',
    ERR_ETHEREUM_SIGNATURE_LENGTH: 'ERR_ETHEREUM_SIGNATURE_LENGTH',
    ERR_RONIN_OAUTH_TOKEN_INVALID: 'ERR_RONIN_OAUTH_TOKEN_INVALID',
    ERR_RONIN_ADDRESS_IS_BLOCKED_TO_LINK_OTHER_ACCOUNT: 'ERR_RONIN_ADDRESS_IS_BLOCKED_TO_LINK_OTHER_ACCOUNT',
    ERR_RONIN_ADDRESS_IS_BLOCKED_TO_LINK_OTHER_ACCOUNT_IN_24H: 'ERR_RONIN_ADDRESS_IS_BLOCKED_TO_LINK_OTHER_ACCOUNT_IN_24H',
    ERR_LINK_WITH_EXIST_PROFILE: 'ERR_LINK_WITH_EXIST_PROFILE',
    ERR_ACCOUNT_CONNECTED_WITH_OTHER_EMAIL: 'ERR_ACCOUNT_CONNECTED_WITH_OTHER_EMAIL',
    ERR_PASSWORD_RESET_WRONG_EMAIL_OR_TOKEN: 'ERR_PASSWORD_RESET_WRONG_EMAIL_OR_TOKEN',
    ERR_PASSWORD_RESET_TOKEN_EXPIRED: 'ERR_PASSWORD_RESET_TOKEN_EXPIRED',
    ERR_VERIFY_EMAIL_WRONG_EMAIL_OR_TOKEN: 'ERR_VERIFY_EMAIL_WRONG_EMAIL_OR_TOKEN',
    ERR_VERIFY_EMAIL_WRONG_TOKEN: 'ERR_VERIFY_EMAIL_WRONG_TOKEN',
    ERR_VERIFY_EMAIL_TOKEN_EXPIRED: 'ERR_VERIFY_EMAIL_TOKEN_EXPIRED',
    ERR_VERIFY_EMAIL_TOKEN_ALREADY_SENT: 'ERR_VERIFY_EMAIL_TOKEN_ALREADY_SENT',
    ERR_NON_USER_EMAIL_CHANGE_PASSWORD: 'ERR_NON_USER_EMAIL_CHANGE_PASSWORD',
    ERR_CHANGE_PASSWORD_WRONG_OLD_PASSWORD: 'ERR_CHANGE_PASSWORD_WRONG_OLD_PASSWORD',
    ERR_NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_OLD_PASSWORD: 'ERR_NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_OLD_PASSWORD',
    ERR_THIRD_PARTY_ACCOUNT_UNREGISTERED: 'ERR_THIRD_PARTY_ACCOUNT_UNREGISTERED',
    ERR_EMAIL_NOT_VERIFIED: 'ERR_EMAIL_NOT_VERIFIED',
    ERR_GOOGLE_OAUTH_TOKEN_INVALID: 'ERR_GOOGLE_OAUTH_TOKEN_INVALID',
    ERR_GOOGLE_OAUTH_CLIENT_ID_INVALID: 'ERR_GOOGLE_OAUTH_CLIENT_ID_INVALID',
    ERR_UNLINK_LAST_SOCIAL_ACCOUNT: 'ERR_UNLINK_LAST_SOCIAL_ACCOUNT',
    ERR_ACCOUNT_INACTIVATED: 'ERR_ACCOUNT_INACTIVATED',
    ERR_EMAIL_NOT_MATCH_WITH_GOOGLE_MAIL: 'ERR_EMAIL_NOT_MATCH_WITH_GOOGLE_MAIL',
    ERR_EMAIL_IS_ALREADY_VERIFIED: 'ERR_EMAIL_IS_ALREADY_VERIFIED',
    ERR_RONIN_DOES_NOT_MATCH: 'ERR_RONIN_DOES_NOT_MATCH',
    ERR_CAPTCHA_IS_INVALID: 'ERR_CAPTCHA_IS_INVALID',
    ERR_LOCKED_BY_ATTEMPT_LOGIN: 'ERR_LOCKED_BY_ATTEMPT_LOGIN',
    ERR_ATTEMPT_LOGIN: 'ERR_ATTEMPT_LOGIN',
    ERR_WRONG_2FA_PASSCODE: 'ERR_WRONG_2FA_PASSCODE',
    ERR_ACCESS_KEY_INVALID: 'ERR_ACCESS_KEY_INVALID',
    ERR_2FA_KEY_ALREADY_EXISTS: 'ERR_2FA_KEY_ALREADY_EXISTS',
    ERR_2FA_DISABLED: 'ERR_2FA_DISABLED',
    ERR_2FA_ENABLED_BEFORE: 'ERR_2FA_ENABLED_BEFORE',
    ERR_2FA_INVALID_RECOVERY_CODE: 'ERR_2FA_INVALID_RECOVERY_CODE',
    // ERR_2FA_REQUIRED: 'ERR_2FA_REQUIRED',
    ERR_2FA_USED_RECOVERY_CODE_BEFORE: 'ERR_2FA_USED_RECOVERY_CODE_BEFORE',
    ERR_VALIDATE_SECRET_INVALID_BASE32: 'ERR_VALIDATE_SECRET_INVALID_BASE32',
    ERR_VALIDATE_INPUT_INVALID_LENGTH: 'ERR_VALIDATE_INPUT_INVALID_LENGTH',
    ERR_GENERATE_MISSING_ISSUER: 'ERR_GENERATE_MISSING_ISSUER',
    ERR_GENERATE_MISSING_ACCOUNT_NAME: 'ERR_GENERATE_MISSING_ACCOUNT_NAME',
    ERR_USERID_NOT_FOUND: 'ERR_USERID_NOT_FOUND',
    ERR_USER_ALREADY_SETUP_EMAIL: 'ERR_USER_ALREADY_SETUP_EMAIL',
    ERR_UNABLE_TO_SETUP_BACKUP_CODE: 'ERR_UNABLE_TO_SETUP_BACKUP_CODE',
    ERR_LOGIN_SDK: 'ERR_LOGIN_SDK',
    ERR_OTP_INVALID: 'ERR_OTP_INVALID',
    ERR_USER_EMAIL_NOT_SET: 'ERR_USER_EMAIL_NOT_SET',
    ERR_MFA_INVALID_CODE: 'ERR_MFA_INVALID_CODE',
    ERR_EMAIL_IN_DISPOSABLE_LIST: 'ERR_EMAIL_IN_DISPOSABLE_LIST',
    ERR_UNLINK_RONIN_ADDRESS_WITH_WEB3AUTH: 'ERR_UNLINK_RONIN_ADDRESS_WITH_WEB3AUTH',
    ERR_INVALID_ARGUMENT: `ERR_INVALID_ARGUMENT`,
};
export const API_ERRORS = Object.keys(BE_ERRORS);
//# sourceMappingURL=errors.js.map